import { VisaStatus } from 'types';

import { IVisaStatus } from '../../../../../types';

interface IVisaColorProps {
  visaStatus: IVisaStatus;
}
interface IVisaStatusDescriptionProps {
  visaStatus: IVisaStatus;
}

export const VisaStatusDescription = ({ visaStatus }: IVisaStatusDescriptionProps) => {
  visaStatus = visaStatus || VisaStatus.NONE;
  const youToldText = 'You have told us';
  const pleaseUpdateText = 'Please update this when your situation changes.';

  switch (visaStatus) {
    case VisaStatus.NONE: {
      return <>You have not set a visa status</>;
    }
    case VisaStatus.CAS_NOT_RECEIVED: {
      return (
        <>
          {youToldText} you have <b>not received your CAS document</b>. {pleaseUpdateText}
        </>
      );
    }
    case VisaStatus.VISA_RECEIVED: {
      return (
        <>
          {youToldText} you have <b>received your visa</b>.
        </>
      );
    }
    case VisaStatus.INTENDS_TO_DEFER: {
      return (
        <>
          {youToldText} you <b>intend to defer</b>.
        </>
      );
    }
    case VisaStatus.INTENDS_TO_WITHDRAW: {
      return (
        <>
          {youToldText} you <b>intend to withdraw</b>.
        </>
      );
    }
    case VisaStatus.VISA_REFUSAL: {
      return (
        <>
          {youToldText} you have <b>received a visa refusal</b>.
        </>
      );
    }
    case VisaStatus.UKVI_REQUEST_MORE_INFO: {
      return (
        <>
          {youToldText} <b>UKVI has requested more information from you</b>. {pleaseUpdateText}
        </>
      );
    }
    case VisaStatus.AWAITING_VISA_RESPONSE: {
      return (
        <>
          {youToldText} you are <b>still waiting to hear back from UKVI</b>. {pleaseUpdateText}
        </>
      );
    }
    case VisaStatus.VISA_APPLIED: {
      return (
        <>
          {youToldText} you have <b>applied for your visa</b>. {pleaseUpdateText}
        </>
      );
    }
    case VisaStatus.CAS_RECEIVED: {
      return (
        <>
          {youToldText} you have <b>your CAS but haven't applied for your visa yet</b>. {pleaseUpdateText}
        </>
      );
    }
  }
  return <></>;
};

export const statusColorScheme = ({ visaStatus }: IVisaColorProps) => {
  switch (visaStatus) {
    case VisaStatus.NONE:
    case VisaStatus.AWAITING_VISA_RESPONSE:
    case VisaStatus.VISA_APPLIED:
    case VisaStatus.UKVI_REQUEST_MORE_INFO:
    case VisaStatus.CAS_RECEIVED:
    case VisaStatus.CAS_NOT_RECEIVED:
      return 'orange';

    case VisaStatus.INTENDS_TO_DEFER:
    case VisaStatus.INTENDS_TO_WITHDRAW:
    case VisaStatus.VISA_REFUSAL:
      return 'gray';

    case VisaStatus.VISA_RECEIVED:
      return 'green';

    default:
      return 'orange';
  }
};
